import { ChangeDetectionStrategy, Component, ContentChild, EventEmitter, Input, OnDestroy, OnInit, Output, TrackByFunction } from "@angular/core";
import { BehaviorSubject, combineLatest, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Connote } from "src/app/model/dispatch.model";
import { ConnoteService } from "src/app/services/connote.service";
import { ConnotePickerSearchDirective } from "./connote-picker-search.directive";

@Component({
  selector: 'app-connote-picker',
  templateUrl: './connote-picker.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(blur)': 'onTouched()'
  }
})
export class ConnotePickerComponent implements OnInit, OnDestroy {
  @ContentChild(ConnotePickerSearchDirective, { static: true })
  public readonly searchbox!: ConnotePickerSearchDirective;

  @Input()
  public readonly connote: Connote | null = null;

  @Output()
  public readonly connoteChange = new EventEmitter<Connote | null>();

  private onLeave = new Subject<void>();

  public autocomplete$ = new BehaviorSubject<Connote[]>([]);

  public trackAutoCompleteOptions: TrackByFunction<Connote> = (_, connote) => connote.id;
  
  public constructor(private connotes: ConnoteService) { }

  public ngOnInit() {
    this.searchbox.value = this.connote?.control_no ?? '';
    
    this.connotes.getConnotes({
      include: ['customer'],
      filters: new Map([
        ['run_status_id', [1, 2, 3]]
      ]),
      per_page: -1
    })
    .pipe(takeUntil(this.onLeave))
    .subscribe((connotes) => this.autocomplete$.next(connotes));

    combineLatest([
      this.searchbox.value$,
      this.autocomplete$
    ])
    .pipe(takeUntil(this.onLeave))
    .subscribe(([searchTerm, connotes]) => {
      const match = connotes.find((connote) => connote.control_no.trim().toLowerCase() === searchTerm.trim().toLowerCase());

      if(match && match.id !== this.connote?.id) {
        this.connoteChange.emit(match);
      }
    });
  }

  public ngOnDestroy() {
    this.autocomplete$.complete();
  }
}
